<template>
  <v-flex xs12 md6 lg3>
    <v-card height="100%">
      <v-card-title class="justify-center">
        <h2>{{rate.name}}</h2>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text
        class="payment__card"
        :class="slug === 'groups' ? 'payment__card--group' : 'payment__card--disk'"
      >
        <div class="payment__description" v-if="slug === 'groups'">
          <p>Неограниченное создание групп</p>
          <p>Добавление пользователей в группы</p>
          <p>5GB дискового пространства</p>
        </div>
        <div class="payment__description" v-else-if="slug === 'disk'">
          <p>Дополнительные {{ rate.value }} ГБ на диске</p>
        </div>
        <v-flex v-if="slug === 'disk'" xs12 d-flex>
          <v-select :items="getCompanies" label="Выберите компанию" v-model="select">
            <template slot="selection" slot-scope="data">{{ data.item.name }}</template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-select>
        </v-flex>
        <p class="payment__price">{{ rate.price }} руб. / {{ rate.duration }} дней</p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-3">
        <v-layout row wrap>
          <v-flex xs12>
            <p style="text-align: center;" :class="{'hidden-element' : rate.price === 0}">
              Включая автопродление вы соглашаетесь с
              <a
                href="https://dantser.com/agreement"
              >Пользовательским соглашением</a>
            </p>
          </v-flex>
          <v-checkbox
            style="margin-top: 0"
            :class="{'hidden-element' : rate.price === 0}"
            v-model="autopay"
            label="Включить автопродление"
          ></v-checkbox>
          <v-btn :disabled="!checkConditions" flat @click="getPaymentLink(rate)">Купить</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
  import { mapGetters } from 'vuex'
  import httpClient from '@/api/http-client'

  export default {
    name: 'RateItem',
    props: {
      rate: {
        type: Object,
        required: true
      },
      slug: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        select: '',
        autopay: false,
      }
    },
    computed: {
      ...mapGetters('app/account', ['accountEmail', 'accountPhone', 'getCompanies']),
      checkConditions() {
        if (this.slug === 'groups') {
          return true
        } else {
          if (this.select === '') {
            return false
          } else {
            return true 
          }
        }
      }
    },
    methods: {
      getPaymentLink(item) {
        const order = {
          rate_id: item.id,
          autopay: this.autopay
        }
        if (this.slug === 'disk') {
          httpClient.config.headers['DMS-POST-ID'] = this.select.posts[0].id
        } else {
          delete httpClient.config.headers['DMS-POST-ID']
        }
          
        if (this.accountEmail ) {
          order['email'] = this.accountEmail
        } else {
          order['phone'] = this.accountPhone
        }
        if (item.price === 0) {
          this.$store.dispatch('app/account/paymentInit', order).then(response => this.$dmsSuccessNoty(response))
        } else {
          this.$store.dispatch('app/account/paymentInit', order).then(response => window.location.replace(response.payment_url))
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/apps/account/components/Payment/RateItem.vue